export interface StoneNavItem {
  label: string;
  to: string;
  permission?: string;
}

export const STONE_NAV_ITEMS: StoneNavItem[] = [
  { label: 'Dashboard', to: '/stone-inventory-dashboard' },
  { label: 'Inventory', to: '/stone-inventory-dashboard/inventory', permission: 'OpenTechiz_StoneLogistic::inventory' },
  { label: 'Shipments', to: '/stone-inventory-dashboard/shipments', permission: 'OpenTechiz_StoneLogistic::shipment' },
  { label: 'Receive', to: '/stone-inventory-dashboard/receive', permission: 'OpenTechiz_StoneLogistic::shipment' },
  { label: 'Locations', to: '/stone-inventory-dashboard/locations', permission: 'OpenTechiz_StoneLogistic::location' },
  { label: 'Suppliers', to: '/stone-inventory-dashboard/suppliers', permission: 'OpenTechiz_StoneLogistic::supplier' },
  { label: 'Reports', to: '/stone-inventory-dashboard/reports', permission: 'OpenTechiz_StoneLogistic::reports' },
];
